import humps from 'humps';

const removeEmptyProps = (obj = {}) => {
  const result = {};
  Object.keys(obj).forEach((key) => {
    // Handle numberOfApplicants filter first (before adding to result)
    if (key === 'numberOfApplicants') {
      if (obj[key] === null || obj[key] === 'any' || obj[key] === undefined || obj[key] === '') {
        // 'Any' selected - don't add filter, skip this key
        return;
      }

      // Use the same format as contacts:
      // - For 0 (none): use jobApplicantsCountLteq (<= 0)
      // - For other values: use jobApplicantsCountGteq (>= value)
      // These will be converted to snake_case by decamelizeKeys
      const numValue = typeof obj[key] === 'string' ? parseInt(obj[key], 10) : obj[key];
      if (Number.isNaN(numValue) || numValue < 0) {
        // Invalid numeric value - skip this filter
        return;
      }
      if (numValue === 0) {
        result.jobApplicantsCountLteq = 0;
      } else {
        result.jobApplicantsCountGteq = numValue;
      }
      return;
    }

    if (obj[key] !== '') {
      result[key] = obj[key];
    }
    if (result[key] !== undefined && key === 'sortBy') {
      result[key] = humps.decamelize(result[key]);
    }
    if (key === 'sourcingCampaignStatus') {
      // Handle array values - convert to snake_case for API
      // Empty string is a valid value meaning "not boosted"
      if (Array.isArray(obj[key])) {
        if (obj[key].length === 0) {
          // Empty array - don't include in result
          delete result[key];
        } else {
          // Preserve empty strings in the array as they represent "not boosted"
          result.sourcingCampaignStatus = obj[key];
        }
      } else if (obj[key] !== null && obj[key] !== undefined) {
        // Handle single value (shouldn't happen with multi-select, but handle for safety)
        result.sourcingCampaignStatus = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
      }
    }
  });

  return result;
};

export default removeEmptyProps;
